var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-file-btn",class:_vm.compClass},[_vm._t("default"),_c('input',{staticClass:"file-input",attrs:{"disabled":_vm.disabled,"type":"file","multiple":_vm.multiple},on:{"change":function($event){return _vm.change($event)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }